import React from 'react'
import { motion } from 'framer-motion'

interface IPageTransitionProps {
    children: React.ReactNode
}

function PageTransition({ children }: IPageTransitionProps) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25, ease: 'easeOut' }}
        >
            {children}
        </motion.div>
    )
}

export default PageTransition
